import { Button, CircularProgress, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@material-ui/core";
import React, { useState } from "react";
import { useIsMounted } from "./useIsMounted";

interface Props {
    open: boolean;
    title: string;
    message: React.ReactNode;
    confirmLabel: string;
    destructive?: boolean;
    onConfirm: () => Promise<void> | void;
    onClose: () => void;
}

export const ConfirmDialog: React.FC<Props> = ({ open, title, message, confirmLabel, destructive, onConfirm, onClose }) => {
    const [busy, setBusy] = useState(false);
    const mounted = useIsMounted();

    async function confirm() {
        setBusy(true);
        try {
            await onConfirm();
        } finally {
            if (mounted.current) setBusy(false);
        }
    }

    return (
        <Dialog open={open} onClose={busy ? undefined : onClose} maxWidth="xs" fullWidth>
            <DialogTitle>{title}</DialogTitle>
            <DialogContent>
                <DialogContentText component="div">{message}</DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={busy}>Cancel</Button>
                <Button
                    onClick={confirm}
                    disabled={busy}
                    variant={destructive ? "text" : "contained"}
                    style={destructive ? { color: "red", fontWeight: 700 } : undefined}
                    startIcon={busy ? <CircularProgress size={16} /> : undefined}
                >
                    {confirmLabel}
                </Button>
            </DialogActions>
        </Dialog>
    );
};
